import type { Theme } from '@mui/material/styles';
import type { SxStyles } from '@/ui/style/types';
import { getFocusIndicatorStyles } from '@/ui/style/themeOptionsGenerator';
import { GEOVIEW_SHAPE, geoViewColors as defaultGeoViewColors } from '@/ui/style/default';

/**
 * Gets custom sx classes for the switch component.
 *
 * Uses optional chaining (?.) for theme.palette.geoViewColor properties
 * because plugins may render before GeoView's custom theme is fully initialized.
 *
 * @param theme - The MUI theme object
 * @returns The sx classes object
 */
export const getSxClasses = (theme: Theme): SxStyles => ({
  formControl: {
    margin: theme.spacing(0, 0.5),
    padding: theme.spacing(0, 0.5),
    borderRadius: GEOVIEW_SHAPE.borderRadiusMd,
    gap: theme.spacing(0.5),
    '&:has(.Mui-focusVisible)': {
      ...getFocusIndicatorStyles(theme.palette.geoViewColor ?? defaultGeoViewColors),
    },
    '& .MuiSwitch-root': {
      overflow: 'visible',
    },
    '& .MuiSwitch-switchBase.Mui-focusVisible': {
      color: theme.palette.primary.contrastText,
      background: theme.palette.primary.main,
      outlineColor: 'transparent',
      boxShadow: 'none',
    },
    // This wrapper indicates focus on the whole label, not on the native track as well.
    '& .MuiSwitch-switchBase.Mui-focusVisible ~ .MuiSwitch-track': {
      outline: 'none',
      boxShadow: 'none',
    },
    '& .MuiFormControlLabel-label': {
      fontSize: theme.palette.geoViewFontSize?.default,
      color: 'inherit',
      whiteSpace: 'normal',
    },
  },
});
